export enum RemoteWorkWeekdayExceptionReasonTypeEnum {
  LaboralPersonal = 'laboral_personal',
  External = 'external',
  Illness = 'illness',
}

export const RemoteWorkWeekdayExceptionReasonTypeEnumLabels: Record<string, string> = {
  [RemoteWorkWeekdayExceptionReasonTypeEnum.LaboralPersonal]: 'Laboral/Personal',
  [RemoteWorkWeekdayExceptionReasonTypeEnum.External]: 'Externo',
  [RemoteWorkWeekdayExceptionReasonTypeEnum.Illness]: 'Enfermedad',
};

export const RemoteWorkWeekdayExceptionReasonTypeEnumDescriptions: Record<string, string> = {
  [RemoteWorkWeekdayExceptionReasonTypeEnum.LaboralPersonal]:
    'Motivo por necesidad laboral interna o asunto personal: reunión interna, gestión administrativa o necesidad doméstica puntual...',
  [RemoteWorkWeekdayExceptionReasonTypeEnum.External]:
    'Motivo externo al trabajador y a la empresa: alertas meteorológicas, carreteras cortadas, coche averiado, obras en la oficina...',
  [RemoteWorkWeekdayExceptionReasonTypeEnum.Illness]:
    'Enfermedad leve que permite trabajar desde casa: resfriado, gripe, dolor de cabeza...',
};

export const RemoteWorkWeekdayExceptionReasonTypeEnumProductionKeyPerformanceIndicatorRepercussionDescriptions: Record<string, string> = {
  [RemoteWorkWeekdayExceptionReasonTypeEnum.LaboralPersonal]:
    'Afectará negativamente a la hora de calcular el PKPI de presencialidad con compañeros',
  [RemoteWorkWeekdayExceptionReasonTypeEnum.External]: 'No afectará a la hora de calcular el PKPI de presencialidad con compañeros',
  [RemoteWorkWeekdayExceptionReasonTypeEnum.Illness]: 'No afectará a la hora de calcular el PKPI de presencialidad con compañeros',
};
